<footer class="footer">
  <div class="content has-text-centered">
    <p class="has-text-grey-lighter">__LOCALE_DATE__ __UNIX_TIMESTAMP__</p>
  </div>
</footer>
